<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Almacén</h3>
        </b-col>
        <!-- <b-col class="text-right">
          <a href="#!" class="btn btn-sm btn-primary">See all</a>
        </b-col> -->
      </b-row>
    </template>

    <el-table class="table-responsive table"
              :data="AlmacenUnico"
              header-row-class-name="thead-light"
              :default-sort="{ prop: 'Almacen', order: 'ascending' }" 
              >

              <el-table-column label="Almacén"
                               min-width="250px"
                               prop="Almacen" 
                              >

                              <!-- getColorBasedOnNombreAlmacen(row) -->
                 <template v-slot="{ row }">
                  <div class="font-weight-600" :style="{ color: '#008B8B'}">{{ NombreAlmacen(row) }}</div>
                </template>
              </el-table-column>

      <el-table-column label="Producto"
                       min-width="250px"
                       prop="Producto">
         <template v-slot="{ row }">
         <div class="font-weight-500">{{ProductoAlmacen(row)}}</div>
        </template>
      </el-table-column>



      <el-table-column label="Viajes"
                       min-width="100px"
                       prop="Viajes">
          <template v-slot="{ row }">
         <div class="font-weight-500">{{ViajesBalanzaEnAlmacen(row)}}</div>
        </template>
      </el-table-column>

      <el-table-column label="Manifestado"
                       min-width="140px"  >
          <template v-slot="{ row }">
         <div class="font-weight-500">{{ManifestadoAlmacen(row)}} TM</div>
        </template>
      </el-table-column>

      <el-table-column label="Descargado"
                       min-width="140px">
        <template v-slot="{ row }">
         <div class="font-weight-500">{{PnetoBalanzaEnAlmacen(row)}} TM</div>
        </template> 
           </el-table-column>

           <el-table-column label="Ingresado"
                       min-width="140px">
        <template v-slot="{ row }">
         <div class="font-weight-500"><b>{{PnetoIngresadoEnAlmacen(row)}} TM</b></div>
        </template> 
           </el-table-column>

      <el-table-column label="Saldo"
          min-width="140px">
         <template v-slot="{ row }">
       <div class="font-weight-600" style="color:#F59221" v-if="(PnetoBalanzaEnAlmacen(row) - ManifestadoAlmacen(row)) < 0">{{(PnetoBalanzaEnAlmacen(row) - ManifestadoAlmacen(row)).toFixed(3)}} TM</div>
      <div class="font-weight-600" style="color:#529E02" v-if="(PnetoBalanzaEnAlmacen(row) - ManifestadoAlmacen(row)) >= 0">{{(PnetoBalanzaEnAlmacen(row) - ManifestadoAlmacen(row)).toFixed(3)}} TM</div>
        </template> 
      </el-table-column>

      <el-table-column min-width="250px" label="Progreso">
        <template v-slot="{row}">
          <div class="d-flex align-items-center">
            <span class="mr-2">{{calculateProgress(row)}}%</span>
            <base-progress
              :type="getProgressColor(row)"
              :value="calculateProgress(row)"
              class="custom-progress-bar"
            />

          </div>
        </template>
      </el-table-column>


    </el-table>
  </b-card>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  export default {

    props: {
    listaDatosAlmacenDistribucion: {
      type: Array,
      default: () => [],
    },
    listaDatosData: {
      type: Array,
      default: () => [],
    },
    ListaAlmacenes: {
      type: Array,
      default: () => [],
    },
    
    listaDatos: {
      type: Array,
      default: () => [],
    },
    listaDatosProducto: {
      type: Array,
      default: () => [],
    },
    listaConsignave: {
      type: Array,
      default: () => [],
    },
    listaClientesNave: {
      type: Array,
      default: () => [],
    },
  },
    name: 'almacen-visits-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        uniqueColorMap: {},

      }
    },
    created(){
     },
     computed:{

      DataCompleta() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_PUERTO: this.convertir(item.PESO_NETO_PUERTO),
          PESO_NETO_ALMACEN: this.convertir(item.PESO_NETO_ALMCEN),
          ID_PRODUCTO: item.ID_PRODUCTO,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
        };
            }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        })
              },

              DataCamiones() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PLACA: item.PLACA,
          TRANSPORTE: item.TRANSPORTE
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
        };
            }).filter(function( element ) {
          return element.PLACA !== undefined;
        }).filter(function( element ) {
          return element.PLACA !== undefined;
        })
              },

      mappedItems() {
      return this.listaDatos.map((item) => {
         this.listaDatosProducto.forEach(product => {
        if(product.ID == item.PRODUCTO)
         item.PRODUCTO = product.PRODUCTO
        
        
      this.listaConsignave.forEach(productoxd => {
          if(productoxd.ID  == item.ID_CONSIGNATARIO)
           item.CONSIGNAVE = productoxd.CONSIGNATARIO  
      });

   
      this.listaClientesNave.forEach(clientnave => {
          if(clientnave.ID  == item.CONSIGNAVE)
           item.CONSIGNAVE = clientnave.CONSIGNATARIO  
      });


      });

        return {
          BAGS: item.BAGS,
          BLS: item.BLS,
          CANTIDAD: this.convertir(item.CANTIDAD),
          PRODUCTO: item.PRODUCTO,
          ID: item.ID,
          Consignatario: item.CONSIGNAVE,

          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
        };
     })
       
      
    }, 
    
      AlmacenesDistribution() {
        return this.listaDatosAlmacenDistribucion.map((item) => {
          if (this.listaDatos && this.listaDatos.length > 0) {
            this.listaDatos.forEach(productosnave => {
              if (productosnave.ID == item.ID_PRODUCTO)
                item.PRODUCTO = productosnave.PRODUCTO
            });
          }

          if (this.ListaAlmacenes && this.ListaAlmacenes.length > 0) {
            this.ListaAlmacenes.forEach(almacen => {
              if (almacen.ID == item.ALMACEN)
                item.ALMACEN = almacen.ALMACEN
            });
          }

          return {
            CANTIDAD: this.convertir(item.CANTIDAD),
            PRODUCTO: item.PRODUCTO,
            ALMACEN: item.ALMACEN,
            ID_PRODUCTO: item.ID_PRODUCTO,
            ID: item.ID
          };
        });
      },

    AlmacenUnico() {
      let almacen = [  
         ...new Set(this.listaDatosAlmacenDistribucion.map(almacenlist => almacenlist.ID))
        ]
         return almacen
      },


      ProductoUnico() {
      let producto = [  
      ...new Set(this.listaDatos.map(productlist => productlist.ID))
      ]
      return producto
      },


     },
     methods: {

      getUniqueRandomColor(nombreAlmacen) {
    if (!this.uniqueColorMap[nombreAlmacen]) {
      this.uniqueColorMap[nombreAlmacen] = this.generateRandomColor();
    }
    return this.uniqueColorMap[nombreAlmacen];
  },

  getColorBasedOnNombreAlmacen(row) {
    const nombreAlmacen = this.NombreAlmacen(row);
    const color = this.getUniqueRandomColor(nombreAlmacen);
    return color;
  },

  generateRandomColor() {
    const colors = [
      'rgb(0, 28, 38)',
      'rgb(0, 77, 107)',
      'rgb(190, 219, 225)',
      'rgb(0, 139, 139)',
      'rgb(255, 175, 29)',
      'rgb(255, 104, 0)'
    ];

    return colors[Math.floor(Math.random() * colors.length)];
  },

     convertir(item){
     if(typeof(item)==="string")
     return parseFloat(item.replace(",", "."))

     if (typeof(item)==="number")
     return parseFloat(item.toString())
 

            },

      Producto(idproductophite) {
      let pnetoTotal = ''
      let res =  this.mappedItems.filter(val => {
      return val.ID == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.PRODUCTO
      });

      return pnetoTotal;

      },

      PnetoBalanzaEnAlmacen(idalmacenphite) {
         let pnetoTotal = 0
        let res =  this.DataCompleta.filter(val => {
            return val.ID_DIST_PRODCUTO_ALM == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_PUERTO
        });

      return pnetoTotal.toFixed(3);

      },

      PnetoIngresadoEnAlmacen(idalmacenphite) {
         let pnetoTotal = 0
        let res =  this.DataCompleta.filter(val => {
            return val.ID_DIST_PRODCUTO_ALM == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_ALMACEN
        });

      return pnetoTotal.toFixed(3);

      },
        
      ProductoAlmacen(idalmacenphite) {
      let pnetoTotal = ''
      let res =  this.AlmacenesDistribution.filter(val => {
      return val.ID == idalmacenphite;
      })

      res.forEach(element => {
      pnetoTotal += element.PRODUCTO
      });

      return pnetoTotal;

      },

      NombreAlmacen(idalmacenphite) {
         let pnetoTotal = ''
        let res =  this.AlmacenesDistribution.filter(val => {
            return val.ID == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.ALMACEN
        });

      return pnetoTotal;

      },

      ManifestadoAlmacen(idalmacenphite) {
         let pnetoTotal = 0
        let res =  this.AlmacenesDistribution.filter(val => {
            return val.ID == idalmacenphite;
        })

        res.forEach(element => {
          pnetoTotal += element.CANTIDAD
        });

      return pnetoTotal.toFixed(3);

      },
      
      ViajesBalanzaEnAlmacen(idalmacenphite) 
      {
       let res =  this.DataCompleta.filter(val => {
       return val.ID_DIST_PRODCUTO_ALM == idalmacenphite;
        })

      return res.length;
      },


      ManifestadoBalanza(idproductophite) {
      let pnetoTotal = 0
      let res =  this.mappedItems.filter(val => {
      return val.ID == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.CANTIDAD
      });

      return pnetoTotal.toFixed(3);

      },

      PnetoBalanza(idproductophite) {
      let pnetoTotal = 0
      let res =  this.DataCompleta.filter(val => {
      return val.ID_PRODUCTO == idproductophite;
      })

      res.forEach(element => {
      pnetoTotal += element.PESO_NETO_PUERTO
      });

      return pnetoTotal.toFixed(3);

      },

      calculateProgress(row) {
    const Pneto = this.PnetoBalanzaEnAlmacen(row);
    const Manifestado = this.ManifestadoAlmacen(row);

    // Asegurarse de que los valores son números y que Manifestado no es cero
    if (!isNaN(Pneto) && !isNaN(Manifestado) && Manifestado > 0) {
        const progress = (Pneto / Manifestado) * 100;
        const limitedProgress = Math.min(Math.max(progress, 0), 100); // Limitar entre 0 y 100
        return parseFloat(limitedProgress.toFixed(2)); // Redondear a 2 decimales y convertir a número
    }
    return 0; // Devolver 0 si los datos no son válidos
},

      getProgressColor(row) {
    const progress = this.calculateProgress(row);

    if (progress <= 30) {
      return 'orange';
    } else if (progress <= 97) {
      return 'yellow';
    } else {
      return 'green';
    }
  },

         }
         

  }
</script>
<style>

.custom-progress-bar.orange {
  background-color: #FF6800;
}

.custom-progress-bar.yellow {
  background-color: #FFAF1D;
}

.custom-progress-bar.green {
  background-color: #38c172;
}


</style>